// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3887":"bbede1af","4670":"22547510","5646":"bbede1af"}[chunkId] + ".chunk.css";
};